import React from 'react';

import { Grid, Paper, Stack, Typography } from '@mui/material';

import { useScreenInfo } from 'src/hooks/common';
import { useResourceList } from 'src/hooks/resources/useResourceList';
import { SxProp } from 'src/types/mui';

import { ResourceCard } from '../resource';

export const InboxItemContentResources: React.FC = () => {
  const { resourcesList } = useResourceList();
  const { isMobile } = useScreenInfo();

  const renderTitleCard = React.useCallback(
    () => (
      <Paper sx={paperStyles}>
        <Typography variant="h6">Finally your account has been created!</Typography>
        <Typography variant="body2" mt={1}>
          Clear Verify Team happy to welcome you! Check out some useful widgets and set up your
          account
        </Typography>
      </Paper>
    ),
    [],
  );

  if (isMobile) {
    return (
      <Stack gap={4}>
        {renderTitleCard()}
        <Stack direction="column" spacing={2}>
          {resourcesList.map(card => (
            <Paper key={card.id} variant="outlined">
              <ResourceCard resource={card} />
            </Paper>
          ))}
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack gap={4}>
      {renderTitleCard()}
      <Grid container spacing={2}>
        {resourcesList.map(card => (
          <Grid key={card.id} size={{ xs: 12, md: 6 }}>
            <ResourceCard resource={card} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

const paperStyles: SxProp = {
  padding: '24px',
  boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.05)',
};
